import { useTranslation } from 'react-i18next';

import { DEPT_TYPE } from 'types/enumType';

export default function DeptOption() {
  const { t } = useTranslation();
  return (
    <>
      <option value={DEPT_TYPE.PROD}>{t('home.prod')}</option>
      <option value={DEPT_TYPE.ELEC}>{t('home.elec')}</option>
      <option value={DEPT_TYPE.MECH}>{t('home.mech')}</option>
    </>
  );
}
